import React, { useEffect, useRef, useState } from "react";
import QRCode from "react-qr-code";
import {
  Button,
  ButtonForwardRef,
  CardContent,
  CurrencyInput,
  Dialog,
  DialogContent,
  TextField,
} from "../../../../../components";
import { value } from "../../../../../helpers";
import { TefHubService } from "../../../../../services";
import palette from "../../../../../styles/light-theme/palette";
import { unformatPrice } from "../../../../../utils";
import { DATATYPE_TEF } from "../../../../../resources";
import { stringsParaCancelamento } from "../../../../../resources/constantes";
import Mousetrap from "mousetrap";

const tefHubService = new TefHubService();
const creditCardGif = "https://public.siafevolution.com.br/credit-card.gif";

const MenuPagamentoTef = ({
  open,
  setOpen,
  dadosMenuTef,
  setDadosMenuTef,
  tefConnection,
}) => {
  const { dataType, titulo, itensMenu, mensagem, tamanhoMaximo, qrCode } =
    dadosMenuTef || {};
  const [respostaSitef, setRespostaSitef] = useState(null);
  const modulosConfirmacao = [DATATYPE_TEF.CONFIRMATION, DATATYPE_TEF.QRCODE];

  const respostaRef = useRef(respostaSitef);
  const dadosRef = useRef(dadosMenuTef);
  const itensMenuSizeRef = useRef(itensMenu?.length);
  const itemRefs = useRef([]);
  const inputNumericRef = useRef(null);

  const botaoContinuarRef = useRef(null);
  const botaoConfirmarRef = useRef(null);
  const botaoCancelarRef = useRef(null);

  const atalhosMenuAdm = [
    {
      keys: ["enter"],
      action: (e) => {
        e.preventDefault();
        if (
          dadosRef.current?.dataType &&
          !modulosConfirmacao.includes(dadosRef.current?.dataType)
        ) {
          if (botaoContinuarRef.current) {
            const el = botaoContinuarRef.current;
            mockButtonClick(el);
          }
        } else if (dadosRef.current?.dataType === DATATYPE_TEF.CONFIRMATION) {
          if (botaoConfirmarRef.current) {
            const el = botaoConfirmarRef.current;
            mockButtonClick(el);
          }
        }
        return false;
      },
    },
    {
      keys: ["esc"],
      action: (e) => {
        if (
          dadosRef.current?.dataType === DATATYPE_TEF.CONFIRMATION || 
          dadosRef.current?.qrCode || 
          stringsParaCancelamento.includes(dadosRef.current?.mensagem)
        ) {
          e.preventDefault();
          const el = botaoCancelarRef.current;
          mockButtonClick(el);
        }
        return false;
      },
    },
    {
      keys: ["up"],
      action: () => {
        if (dadosRef.current?.dataType === DATATYPE_TEF.MENU) {
          const index = parseInt(respostaRef.current ?? "1") - 1;
          if (index > 0) {
            setRespostaSitef(`${index}`);
          }
        }
        return false;
      },
    },
    {
      keys: ["down"],
      action: () => {
        if (dadosRef.current?.dataType === DATATYPE_TEF.MENU) {
          const index = parseInt(respostaRef.current ?? "1") + 1;
          if (index <= itensMenuSizeRef.current) {
            setRespostaSitef(`${index}`);
          }
        }
        return false;
      },
    },
  ];

  const mockButtonClick = (el) => {
    el.dispatchEvent(new MouseEvent("mousedown", { bubbles: true }));

    setTimeout(() => {
      el.dispatchEvent(new MouseEvent("mouseup", { bubbles: true }));
      el.dispatchEvent(new MouseEvent("click", { bubbles: true }));
    }, 200);
  };

  useEffect(() => {
    if (!open) return;
    atalhosMenuAdm.map(({ keys, action }) => Mousetrap.bind(keys, action));

    return () => {
      atalhosMenuAdm.map(({ keys }) => Mousetrap.unbind(keys));
    };
  }, [open]);

  useEffect(() => {
    respostaRef.current = respostaSitef;
    const index = parseInt(respostaSitef ?? "1") - 1;
    const el = itemRefs.current[index];
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [respostaSitef]);

  useEffect(() => {
    dadosRef.current = dadosMenuTef;
    itensMenuSizeRef.current = itensMenu?.length;
    itemRefs.current =
      itensMenu?.map((_, i) => itemRefs.current[i] ?? React.createRef()) ?? [];
    if (dataType === DATATYPE_TEF.MENU) {
      setRespostaSitef("1");
    } else if (
      dataType === DATATYPE_TEF.CURRENCY ||
      dataType === DATATYPE_TEF.NUMERIC
    ) {
      inputNumericRef.current?.focus();
    }
  }, [dadosMenuTef]);

  Mousetrap.stopCallback = function () {
    return false;
  };

  const handleChangeCurrency = (event) => {
    setRespostaSitef(parseFloat(unformatPrice(event.target.value)));
  };

  const handleChangeNumber = (event) => {
    const value = event.target.value;
    const length = value?.length ?? 0;
    if (length <= tamanhoMaximo) {
      setRespostaSitef(event.target.value);
    }
  };

  const handleOnKeyDown = (event) => {
    if (event.key === "Enter") {
      const el = botaoContinuarRef.current;
      if (el) {
        mockButtonClick(el);
      }
    }
  };

  const handleCloseDialog = async () => {
    setOpen(false);
    setDadosMenuTef({});
    await tefConnection.disconnect();
  };

  const callbackSitef = async (interromper, voltar, respostaSitef) => {
    await tefHubService.callback({
      interromper,
      voltar,
      respostaSitef,
    });
    setRespostaSitef(null);
  };

  const validarBotaoCancelamento = () => {
    return qrCode || stringsParaCancelamento.includes(mensagem);
  };

  const renderMenuTef = () => {
    switch (dataType) {
      case DATATYPE_TEF.CURRENCY:
        return (
          <>
            <span style={{ fontWeight: 600, fontSize: 16 }}>{titulo}</span>
            <CurrencyInput
              id="valor"
              variant="outlined"
              autoFocus
              required
              value={value.text(respostaSitef)}
              onChange={handleChangeCurrency}
              onKeyDown={handleOnKeyDown}
              fullWidth
            />
          </>
        );
      case DATATYPE_TEF.NUMERIC:
        return (
          <>
            <span style={{ fontWeight: 600, fontSize: 16 }}>{titulo}</span>
            <TextField
              id="valor"
              inputRef={inputNumericRef}
              variant="outlined"
              margin="normal"
              type="number"
              fullWidth
              value={value.text(respostaSitef)}
              onChange={handleChangeNumber}
              onKeyDown={handleOnKeyDown}
            />
          </>
        );
      case DATATYPE_TEF.MENU:
        return (
          <>
            <span style={{ fontWeight: 600, fontSize: 16 }}>{titulo}</span>
            <div className="px-5 d-flex flex-column gap-2">
              {itensMenu?.map((item, i) => (
                <div key={i} ref={(el) => (itemRefs.current[i] = el)}>
                  <Button
                    key={i}
                    fullWidth
                    variant="contained"
                    size="small"
                    className="mt-2 rounded-3"
                    disableElevation
                    onClick={() => setRespostaSitef(`${i + 1}`)}
                    sx={{
                      backgroundColor:
                        respostaSitef === `${i + 1}`
                          ? palette.primary
                          : "white",
                      color: respostaSitef === `${i + 1}` ? "white" : "black",
                    }}
                  >
                    {item}
                  </Button>
                </div>
              ))}
            </div>
          </>
        );
      case DATATYPE_TEF.CONFIRMATION:
        return (
          <>
            <span style={{ fontWeight: 600, fontSize: 16 }}>{mensagem}</span>
            <div className="d-flex flex-row gap-2">
              <ButtonForwardRef
                ref={botaoConfirmarRef}
                color="primary"
                variant="contained"
                onClick={async () => {
                  callbackSitef(false, false, "0");
                  await handleCloseDialog();
                }}
              >
                <i
                  className="ph-fill ph-check-circle"
                  style={{ fontSize: 22, marginRight: 10, color: "white" }}
                />
                Confirmar
              </ButtonForwardRef>
              <ButtonForwardRef
                ref={botaoCancelarRef}
                color="inherit"
                variant="contained"
                onClick={() => callbackSitef(true, false, "1")}
              >
                <i
                  className="ph-fill ph-x-circle"
                  style={{ fontSize: 22, marginRight: 10 }}
                />
                Cancelar
              </ButtonForwardRef>
            </div>
          </>
        );
      default:
        return (
          <>
            {mensagem && (
              <span style={{ fontWeight: 600, fontSize: 16 }}>{mensagem}</span>
            )}
            {qrCode ? (
              <QRCode value={qrCode} style={{ height: "fit-content" }} />
            ) : (
              <img
                src={creditCardGif}
                alt="Cartão de crédito animado"
                style={{ width: "100px" }}
              />
            )}
            {validarBotaoCancelamento() && (
              <ButtonForwardRef
                ref={botaoCancelarRef}
                color="inherit"
                variant="contained"
                onClick={() => tefConnection.invokeInterrompeRequisicaoTef()}
              >
                <i
                  className="ph-fill ph-x-circle"
                  style={{ fontSize: 22, marginRight: 10 }}
                />
                Cancelar
              </ButtonForwardRef>
            )}
          </>
        );
    }
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      PaperComponent="div"
      PaperProps={{
        style: {
          borderRadius: "0.7rem",
          background: `linear-gradient(180deg, ${palette.white} 98%, ${palette.white} 98%, ${palette.primary.main} 2%)`,
        },
      }}
      open={open}
      onClose={() => setOpen(false)}
      disableEscapeKeyDown
    >
      <DialogContent
        sx={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 4,
        }}
      >
        <h6 className="text-center text-uppercase fw-bold mb-0">
          Pagamento via TEF
        </h6>
        <CardContent
          sx={{
            p: 0,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
          }}
        >
          {renderMenuTef()}
          {dataType && !modulosConfirmacao.includes(dataType) && (
            <ButtonForwardRef
              ref={botaoContinuarRef}
              color="primary"
              variant="contained"
              disabled={!respostaSitef}
              onClick={() => callbackSitef(false, false, respostaSitef)}
            >
              Continuar
            </ButtonForwardRef>
          )}
        </CardContent>
      </DialogContent>
    </Dialog>
  );
};

export default MenuPagamentoTef;
